import * as THREE from 'three';
import * as CANNON from 'cannon-es';

export class Bullet {
  public mesh: THREE.Mesh;
  public body: CANNON.Body;
  public isActive: boolean = true;
  public lifetime: number = 5; // 5 秒后自动销毁
  private age: number = 0;
  public owner: 'player' | 'enemy';

  constructor(
    position: THREE.Vector3,
    direction: THREE.Vector3,
    owner: 'player' | 'enemy' = 'player'
  ) {
    this.owner = owner;

    // 创建子弹网格
    const geometry = new THREE.SphereGeometry(0.2, 8, 8);
    const material = new THREE.MeshStandardMaterial({
      color: owner === 'player' ? 0xffff00 : 0xff0000,
      emissive: owner === 'player' ? 0xffff00 : 0xff0000,
      emissiveIntensity: 0.5
    });
    this.mesh = new THREE.Mesh(geometry, material);
    this.mesh.position.copy(position);
    this.mesh.castShadow = true;

    // 创建物理体
    const shape = new CANNON.Sphere(0.2);
    this.body = new CANNON.Body({
      mass: 1,
      shape: shape,
      position: new CANNON.Vec3(position.x, position.y, position.z),
      collisionFilterGroup: 1,  // 子弹组
      collisionFilterMask: -1   // 与所有物体碰撞
    });

    // 设置初始速度
    const speed = 50;
    this.body.velocity.set(
      direction.x * speed,
      direction.y * speed,
      direction.z * speed
    );

    // 添加用户数据用于碰撞检测
    this.body.userData = { type: 'bullet', owner: owner, bullet: this };

    console.log(`Bullet created at (${position.x}, ${position.y}, ${position.z}) by ${owner}`);
  }

  update(deltaTime: number): void {
    this.age += deltaTime;

    if (this.age >= this.lifetime) {
      this.isActive = false;
      return;
    }

    // 同步网格位置到物理体
    this.mesh.position.copy(this.body.position as any);
    this.mesh.quaternion.copy(this.body.quaternion as any);
  }

  destroy(): void {
    this.isActive = false;
  }
}
